import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-light/10">
      <button
        className="w-full py-5 px-2 flex justify-between items-center text-left transition-colors hover:bg-light/5 focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <h3 className="text-lg md:text-xl font-medium text-light">{question}</h3>
        <span className="text-accent ml-2">
          {isOpen ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
        </span>
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 pb-6 px-2' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-light/80">{answer}</p>
      </div>
    </div>
  );
};

const PricingFAQ = () => {
  const faqItems = [
    {
      question: "What's included in the free introductory call?",
      answer: "A 30-minute discussion to understand your goals, challenges, and determine if we're a good fit for each other. This is a no-obligation consultation."
    },
    {
      question: "How do I pay for services?",
      answer: "We accept all major credit cards through our secure payment processor. For larger projects, we can also arrange invoicing."
    },
    {
      question: "Do you offer discounts for longer engagements?",
      answer: "Yes, for clients who commit to retainer agreements of 3+ months, we offer preferential rates. Contact us for details."
    },
    {
      question: "What if I need to cancel a scheduled session?",
      answer: "We understand that business priorities shift. Cancellations made 24+ hours in advance incur no fees. Last-minute cancellations may be subject to a partial fee."
    },
    {
      question: "Can I upgrade from a strategy session to an ongoing engagement?",
      answer: "Absolutely. Many clients start with a focused session and then transition to a standard engagement as they see value in ongoing collaboration."
    }
  ];

  return (
    <div className="mt-16">
      <h2 className="text-2xl md:text-3xl font-bold text-light mb-8 text-center">
        Frequently Asked Questions
      </h2>
      <div className="max-w-3xl mx-auto bg-dark/50 border border-light/10 rounded-xl overflow-hidden">
        {faqItems.map((item, index) => (
          <FAQItem 
            key={index} 
            question={item.question} 
            answer={item.answer} 
          />
        ))}
      </div>
    </div>
  );
};

export default PricingFAQ;